var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-personal-details",
                              title: "Редактировать анкету физ. лица",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "PageContent",
                            { attrs: { height: "90" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Фамилия*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "surname",
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.surname,
                                              "error-messages":
                                                _vm.validationErrors.surname,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.surname.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.surname,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "surname",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.surname",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Имя*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "name",
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.name,
                                              "error-messages":
                                                _vm.validationErrors.name,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.name.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Отчество")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.patronymic,
                                              "error-messages":
                                                _vm.validationErrors.patronymic,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.patronymic,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "patronymic",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.patronymic",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Телефон*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "phone",
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.phone,
                                              "error-messages":
                                                _vm.validationErrors.phone,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.phone.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.phone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "phone",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.phone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Эл.почта*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "email",
                                              value: "",
                                              autofocus: !_vm.fields.email,
                                              "error-messages":
                                                _vm.validationErrors.email,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.email.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.email",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isLocales: false,
                      "is-new": false,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "is-loading": _vm.loading,
                      "is-submit-disabled": _vm.disabled,
                      "entity-id": _vm.data.id,
                      "entity-type": "personalDetail",
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-detail")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({
                          name: "page-personal-details",
                        })
                      },
                      submit: _vm.submit,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }